"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = {
  VERTICAL: 'orientation-vertical',
  HORIZONTAL: 'orientation-horizontal'
};
exports.default = _default;